import { Accordion } from "@mui/material";
import styled from "styled-components";

interface IStyledAccordion {
    noBorder?: boolean;
    iconPosition?: "left" | "right";
}

const StyledAccordion = styled(Accordion)<IStyledAccordion>`
    background-color: ${(props) => props.theme.mainBackground};
    border: none !important;

    &:not(:last-of-type) {
        border-bottom: 1px solid
            ${(props) => props.theme.tableHeadCellSortIconHover} !important;
    }

    &:before {
        display: none;
    }

    &.MuiAccordion-root.Mui-expanded {
        margin: 0 !important;
    }

    .MuiAccordionSummary-root {
        flex-direction: ${(props) =>
            props.iconPosition === "right" ? "row" : "row-reverse"};
        padding-left: ${(props) =>
            props.iconPosition === "right" ? "16px" : "8px"};
        gap: 16px;
        background-color: ${(props) => props.theme.mainBackground};
        border: none !important;

        &:hover {
            background-color: ${(props) => props.theme.homeBackground};
        }

        .MuiAccordionSummary-content {
            color: ${(props) => props.theme.textPrimary};
        }
    }
    .MuiAccordionSummary-root.Mui-expanded {
        min-height: 48px !important;
    }
    .MuiAccordionSummary-content.Mui-expanded {
        margin: 12px 0 !important;
    }

    .MuiAccordionSummary-expandIconWrapper > svg {
        color: ${(props) => props.theme.tableIconMain};
    }

    .MuiAccordionDetails-root {
        background-color: ${(props) => props.theme.mainBackground};
        color: ${(props) => props.theme.textPrimary};
        border-left: ${(props) =>
            props.noBorder ? "none" : "2px solid " + props.theme.tableIconMain};
        border-top: unset;
        border-radius: 0;
    }
`;

export default StyledAccordion;
